import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-quadro-adm',
  templateUrl: './consulta-quadro-adm.component.html',
  styleUrls: ['./consulta-quadro-adm.component.scss']
})
export class ConsultaQuadroAdmComponent implements OnInit {
  title = "QUADRO ADMINISTRATIVO";

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
  }

}
